// src/services/produtos/ProdutoFornecService.js
import { fetchData } from '../Api';

export const buscarFornecedoresPorProduto = (produtoId) =>
    fetchData(`/ProdutoFornec/GetByProdutoId?produtoId=${produtoId}`);
